export default {
  recommendedShopsTitle: {
    gb: 'Browse More Gear From Top Shops in the UK',
    default: 'Browse Top Shops',
  },
};
